export default "__VITE_ASSET__CnfODW1T__"